import { render } from "./form-objective.vue?vue&type=template&id=2c03b1cf&ts=true"
import script from "./form-objective.vue?vue&type=script&lang=ts"
export * from "./form-objective.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__